import Loadable from 'react/components/loadable';

const DashboardV2 = Loadable({
  loader: () => import('../../pages/dashboard/dashboard_v2'),
});

angular.module('gym').value('DashboardV2', DashboardV2);
